export var passEventToUnderLayingEvent = function passEventToUnderLayingEvent(event) {
  setTimeout(function () {
    if (event.clientX && event.clientY) {
      var elem = document.elementFromPoint(event.clientX, event.clientY);
      if (elem) {
        elem.dispatchEvent(event.nativeEvent);
      }
    }
  }, 0);
};